import { Avatar } from '@mui/material';
import { WsColors } from 'wisestep-base';

interface CandidateAvatarProps {
  name: string;
  src?: string;
}

const getInitials = (name: string) => {
  if (name) {
    const names = name.split(' ');
    return names[0][0].toUpperCase() + '' + (names[1] ? names[1][0].toUpperCase() : '');
  }
  return '-';
};

const CandidateAvatar = ({ name, src = '' }: CandidateAvatarProps) => {
  if (src) {
    return <Avatar alt={name} src={src} sx={{ width: '36px', height: '36px' }} />;
  }
  return (
    <Avatar
      sx={{
        bgcolor: WsColors.TheBlues200,
        color: WsColors.GreyText,
        width: '36px',
        height: '36px',
      }}
    >
      {getInitials(name)}
    </Avatar>
  );
};

export default CandidateAvatar;
